export const IS_PRODUCTION = true; // process.env.NODE_ENV === "production";
export const IMAGE_URL = IS_PRODUCTION
  ? "https://api.trybuy.club/listing/listing/images/"
  : "http://localhost:3001/listing/listing/images/";
